import BaseLayoutView from 'app/src/views/base/BaseLayoutView';
import gatewayLSPaymentsViewTemplate from './templates/gateway-lspayments-view.hbs';

// configure
let View = BaseLayoutView.extend({
  template: gatewayLSPaymentsViewTemplate,
});

// define
export default class GatewayLSPaymentView extends View {}
